export const getDateDiff = releaseTime => {
    if (typeof releaseTime !== 'number') {
        return;
    };
    let publishTime = parseInt(releaseTime, 10);
    let d_seconds = 0;
    let d_minutes = 0;
    let d_hours = 0;
    let d_days = 0;
    let timeNow = parseInt(new Date().getTime() / 1000, 10);
    let d = 0;
    let date = new Date(releaseTime * 1000);
    let Y = date.getFullYear();
    let M = date.getMonth() + 1;
    let D = date.getDate();
    // 小于10的在前面补0
    if (M < 10) {
        M = '0' + M;
    }
    if (D < 10) {
        D = '0' + D;
    }
    d = timeNow - publishTime;
    d_days = parseInt(d / (60 * 60 * 24), 10);
    d_hours = parseInt(d / (60 * 60), 10);
    d_minutes = parseInt(d / 60, 10);
    d_seconds = parseInt(d, 10);
    if (d_days >= 30) {
        return Y + '-' + M + '-' + D;
    } else if (d_days >= 1 && d_days < 30) {
        return d_days + '天前';
    } else if (d_days < 1 && d_hours > 0) {
        return d_hours + '小时前';
    } else if (d_hours <= 0 && d_minutes > 0) {
        return d_minutes + '分钟前';
    } else if (d_seconds < 60) {
        return '刚刚';
    };
};